import styled from 'styled-components';
import { ReactComponent as Icon } from './Lotus.svg';

export const Lotus = styled(Icon)`
  fill: currentColor;
  display: block;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;
